import { render } from "./Damrongdhama.vue?vue&type=template&id=5f2d27aa&scoped=true&ts=true"
import script from "./Damrongdhama.ts?vue&type=script&lang=ts"
export * from "./Damrongdhama.ts?vue&type=script&lang=ts"

import "./Damrongdhama.scss?vue&type=style&index=0&id=5f2d27aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2d27aa"]])

export default __exports__